import React from "react";
import { classNames } from "./utils/classNames";
export var Badge = function (_a) {
    var color = _a.color, extraClass = _a.extraClass, text = _a.text;
    return (React.createElement("span", { className: classNames("badge", color, extraClass || "") }, text));
};
